import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  //worldcup promo + xmas pages in promo module/route + TODO add landings later
  { path: 'promo', loadChildren: () => import('./promo/promo.module').then(m => m.PromoModule) },
  { path: 'xmas', redirectTo: 'promo/xmas', pathMatch: 'full' },
  { path: 'xmas/:lang', redirectTo: 'promo/xmas/:lang', pathMatch: 'full' },

  { path: '', loadChildren: () => import('./main/main.module').then(m => m.MainModule) },
  { path: '**', redirectTo: '/', pathMatch: 'full' },
]


@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: "enabled" })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
